import { render, staticRenderFns } from "./IntegrationIcon.vue?vue&type=template&id=03454fcc&"
import script from "./IntegrationIcon.vue?vue&type=script&lang=js&"
export * from "./IntegrationIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports